module.exports = __webpack_public_path__ + "img/Noctiluca-2-mobile.267a1870.png";